class MediaLibrary extends HTMLElement {
    constructor() {
        super();
        this.featuredMediaRows = [];
    }

    connectedCallback() {
        this.featuredMediaRows = this.querySelectorAll(".regularSwiper");

        this.featuredMediaRows.forEach(row => {
            new Swiper(row, {
                slidesPerView: 1, // default mobile
                spaceBetween: 20,
                loop: true,
                navigation: {
                    nextEl: row.querySelector(".swiper-button-next"),
                    prevEl: row.querySelector(".swiper-button-prev"),
                },
                scrollbar: {
                    el: row.querySelector(".swiper-scrollbar"),
                    draggable: true,
                    hide: false,
                },
                breakpoints: {
                    640: {
                        slidesPerView: 1,
                        spaceBetween: 20,
                    },
                    1024: {
                        slidesPerView: 2,
                        spaceBetween: 30,
                    },
                    1425: {
                        slidesPerView: 2.5,
                        spaceBetween: 40,
                    },
                },
            });
        });

        this.featuredMediaRowsShorts = this.querySelectorAll(".shortSwiper");

        this.featuredMediaRowsShorts.forEach(row => {
            new Swiper(row, {
                slidesPerView: 1, // default mobile
                spaceBetween: 20,
                loop: true,
                navigation: {
                    nextEl: row.querySelector(".swiper-button-next"),
                    prevEl: row.querySelector(".swiper-button-prev"),
                },
                scrollbar: {
                    el: row.querySelector(".swiper-scrollbar"),
                    draggable: true,
                    hide: false,
                },
                breakpoints: {
                    440: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                    },
                    640: {
                        slidesPerView: 2.5,
                        spaceBetween: 20,
                    },
                    800: {
                        slidesPerView: 3,
                        spaceBetween: 30,
                    },
                    900: {
                        slidesPerView: 3.5,
                        spaceBetween: 30,
                    },
                    1000: {
                        slidesPerView: 4,
                        spaceBetween: 30,
                    },
                    1310: {
                        slidesPerView: 5,
                        spaceBetween: 40,
                    },
                },
            });
        });
    }
}

customElements.define("media-lib", MediaLibrary);
